import React, { useRef } from 'react';
import { PeekMenuList } from '@piiqtechnologies/ui-components';
import { usePannellumViewer } from '../pannellum-viewer/PannellumProvider.js';
import { ViewerNavMenuItem } from './ViewerNavMenuItem.js';
import 'tslib';
import '../../../types/AccessDevice.js';
import '../../../types/Analytics.js';
import '../../../types/CASACommunity.js';
import '../../../types/Community.js';
import '../../../types/DxSettings.js';
import '../../../types/MagicButton.js';
import '../../../types/Pannellum.js';
import '../../../types/Prospect.js';
import '../../../types/ProspectIntelligence.js';
import '../../../types/Space.js';
import '../../../types/Tour.js';
import '../../../vendor/pannellum/js/libpannellum.js';
import '../../../vendor/pannellum/js/pannellum.js';
import 'react-dom';
import 'linkify-react';
import '@piiqtechnologies/svg-icons';
import '../../../services/base/baseDiscoverService.js';
import '../../../services/base/baseV3Service.js';
import '../../../services/base/baseInsightsService.js';
import '../../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../../utils/ErrorProvider.js';
import '../../../utils/LoaderProvider.js';
import '../../../utils/RefetchProvider.js';
import '../../../utils/NotificationProvider.js';
import '../../../utils/ContactProvider.js';
import '../../../utils/PolicyProvider.js';
import '../../../utils/AnalyticsProvider.js';
import '../../../utils/analyticsPlugin.js';
import '../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../utils/cookieUtils.js';
import '../../../utils/termsConditionsAgreementsUtils.js';
import '../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../services/base/internalApiBaseService.js';
import '../../../services/base/casaBaseService.js';
import '../../../services/scanRequestsService.js';
import '../../../services/db/insightsReportsDB.js';
import 'dot-object';
import '../../../apis/analytics/useDownloadAnalyticsReports.js';
import '../../../apis/upload/useSignedURL.js';
import 'immer';
import '../pannellum-viewer/multiresStore.js';
import { useLoadScene } from '../pannellum-viewer/useNavigateScene.js';

const ViewerRooms = ({ onRoomSelect }) => {
    const { details, token, setViewerContext, getConfig } = usePannellumViewer();
    const firstMenuNavigationRef = useRef(false);
    const { loadSceneWithStageCheck } = useLoadScene();
    const { nodeId } = getConfig();
    const onViewerRoomItemClick = (_id, _details) => {
        loadSceneWithStageCheck(_id, _details, token, true);
        if (!firstMenuNavigationRef.current) {
            firstMenuNavigationRef.current = true;
        }
        setViewerContext({ firstMenuNavigation: firstMenuNavigationRef.current });
        onRoomSelect && onRoomSelect();
    };
    return (React.createElement(PeekMenuList, { disablePadding: true }, details.nodes.map((item) => (React.createElement(ViewerNavMenuItem, { onClick: (id) => onViewerRoomItemClick(id, details), key: item === null || item === void 0 ? void 0 : item._id, name: item.label, itemId: item === null || item === void 0 ? void 0 : item._id, selectedItemId: nodeId, disablePadding: true })))));
};

export { ViewerRooms, ViewerRooms as default };
